import React from 'react';

import { imageHooks, ImageSize } from '@nxte-nl/image-hooks';

import { ImagePresentational } from '../../types/common';

export type Props = {
  className?: string;
  height?: string | number;

  image: ImagePresentational | null;
  onLoadCallback?: () => void;
  size: ImageSize;
  style?: React.CSSProperties;
  width?: string | number;
};

type Ref = HTMLImageElement | null;

export const ImageWithSize = React.forwardRef<Ref, Props>((props, ref) => {
  const {
    image,
    size,

    className,
    style,
    width,
    height,
    onLoadCallback,
  } = props;

  const imageHref = imageHooks.useSize(size, image?.url.href ?? '');

  return imageHref !== '' ? (
    <img
      alt={image?.alt ?? ''}
      src={imageHref}
      className={className}
      style={style}
      width={width}
      height={height}
      ref={ref}
      onLoad={onLoadCallback}
    />
  ) : null;
});

ImageWithSize.displayName = 'ImageWithSize';
